<template>
  <div id="p-side-bar" :class="{'p-side-bar-show':this.$store.state.showSidebar}" class="d-lg-flex col-lg-2  p-side-bar  flex-column">

            <div class="flex-column p-side-bar-sticky-start" >
              <Loader class="w-100 row" :loading="loading">

                  <div class="row p-side-bar-wrapper">
                        <div  class="p-side-bar-header w-100 row"  >
                            <div @click="switchRouteInToProfile" class="c-pointer p-side-bar-header-avatar-main d-flex  flex-column w-100">
                              <div class="p-side-bar-header-avatar-item d-flex  m-auto align-items-center justify-content-center">
                              </div>
                              <h3 class="p-side-bar-header-avatar-title mt-3 text-center">پروفایل</h3>
                            </div>
                        </div>

                        <div class="p-side-bar-content w-100 row">
                          <ul class="row w-100 mr-0 pr-0 p-side-bar-content-ul">
                            <li @click="changeRoute(data)" v-for="data in menuData" :key="data.id" :class="{'p-side-bar-selected':data.selected}" class="w-100 row p-side-bar-content-item">
                              <span class="p-side-bar-content-item-title w-100 c-pointer" >
                                {{data.title}}
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>


                </Loader>
            </div>

      <div @click="removeOverlay" class="sidebar-overlay"></div>
  </div>
</template>

<script>
import menuData from '../../constants/menuData'
// import settings from '../../modules/settings'


export default {
  name: 'Sidebar',
  // syncSettings: ['authorization'],
  data() {
    return {
      loading       : false,
      menuData      : menuData
    }
  },

  methods: {
    removeOverlay(){
      this.$store.state.showSidebar = false;
    },

    switchRouteInToProfile(data){
      console.log(data,'switchRouteInToProfile');
    },

    changeRoute(data){
      if (data.nameRoute == 'exit') {
        // settings.clear('authorization')
        // this.$router.push({ name: 'login' } );
      }
      else {
        this.$router.push({ name: data.nameRoute } )
      }

      this.$store.state.showSidebar = false; // close sidebar //
    },

  },




}
</script>
